// extracted by mini-css-extract-plugin
module.exports = {"textLimit":"TextLimit_textLimit__3IEY-","errored":"TextLimit_errored__1191Q"};